module.exports = __webpack_public_path__ + "img/extension-logo.6990aa01.jpg";